<template>
    <div>
        <div class="col-lg-8 px-0 mt-4">
            <ul class="input-table">
                <li
                    class="d-flex justify-content-start"
                    v-if="items.length"
                    v-for="(item, index) in items"
                    :key="item.id"
                >
                    <div class="input-table-shadow">
                        <div class="d-flex row align-items-center">
                            <div class="col-5 pl-5 border-right">
                                <core-date-range-calendar
                                    :start.sync="item.dateFrom"
                                    :end.sync="item.dateUntil"
                                ></core-date-range-calendar>
                            </div>
                            <div class="col-4 border-right">
                                <core-drop-down
                                    :items="nights"
                                    :selectedValue.sync="item.nights"
                                    noLabel
                                ></core-drop-down>
                            </div>
                            <div class="col">
                                <input type="text" placeholder="description" v-model="item.description">
                            </div>
                        </div>
                    </div>
                    <div class="pl-2 d-flex align-items-center">
                        <core-icon
                            @click.native="clone(item)"
                            class="pointer"
                            iconName="Clone"
                            iconColor="#bdbdbd"
                        >
                            <icons-clone></icons-clone>
                        </core-icon>
                    </div>
                    <div class="pl-1 d-flex align-items-center">
                        <core-icon
                            @click.native="remove(index)"
                            class="pointer"
                            iconName="Remove"
                            iconColor="#bdbdbd"
                        >
                            <icons-delete></icons-delete>
                        </core-icon>
                    </div>
                </li>
            </ul>
        </div>
        <img
            class="ml-3 add-row"
            src="@/assets/svg/plus008CDD.svg"
            @click="add"
        >
    </div>
</template>

<script>
// import Service from '@/services/hatsApi/Service'
import { addItem } from '@/mixins/addItem'
import { cloneItem } from '@/mixins/cloneItem'
import { removeItem } from '@/mixins/removeItem'

export default {
  data () {
    return {
      items: this.specials,
      dateDisplayFormat: 'DD-MM-YYYY'
    }
  },
  props: {
    specials: {
      default: () => ([]),
      type: Array,
      required: false
    }
  },
  mixins: [addItem, cloneItem, removeItem],
  computed: {
    nights () {
      let nightsList = []
      for (let night = 1; night <= 31; night++) {
        let prefix = 'nachten'
        if (night === 1) {
          prefix = 'nacht'
        }
        nightsList.push({
          id: night,
          name: night + ' ' + prefix
        })
      }
      return nightsList
    }
  },
  methods: {
    async submit () {
      // Todo: Create record. Waiting for price rule for specials
    },
    submitAndClose () {
      this.submit()
    }
  },
  watch: {
    items (val) {
      this.$emit('update:specials', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SpecialsInputTable.vue